var map = {
	"./2020-07-15-welcome/index.mdx": 46895,
	"./2020-09-12-augustupdate/index.mdx": 34699,
	"./2020-10-14-productupdate/index.mdx": 61035,
	"./2020-12-01-productupdate/index.mdx": 15268,
	"./2021-01-18-january/index.mdx": 355,
	"./2021-04-25-april/index.mdx": 65243,
	"./2021-09-01-sept/index.mdx": 38071,
	"./2021-11-07-nov/index.mdx": 27832,
	"src/pages/blog/2020-07-15-welcome/index.mdx": 46895,
	"src/pages/blog/2020-09-12-augustupdate/index.mdx": 34699,
	"src/pages/blog/2020-10-14-productupdate/index.mdx": 61035,
	"src/pages/blog/2020-12-01-productupdate/index.mdx": 15268,
	"src/pages/blog/2021-01-18-january/index.mdx": 355,
	"src/pages/blog/2021-04-25-april/index.mdx": 65243,
	"src/pages/blog/2021-09-01-sept/index.mdx": 38071,
	"src/pages/blog/2021-11-07-nov/index.mdx": 27832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93467;